import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 获取管理员列表
const findByRoleId = obj => new Promise((resolve, reject) => {
    const {
        roleId,
        token
    } = obj;
    request({
        url: apis.admin_find + '?roleId=' + roleId + '&token=' + token,
    }).then(res => {
        resolve(res);
    })
});

// 修改管理员权限
const changeAdminRole = obj => new Promise((resolve, reject) => {
    const {
        gameAdminId,
        roleId,
        token
    } = obj;
    request({
        url: apis.admin_change_role + '?gameAdminId=' + gameAdminId + '&roleId=' + roleId + '&token=' +
            token,
    }).then(res => {
        resolve(res);
    })
});
// 创建管理员
const createAdmin = obj => new Promise((resolve, reject) => {
    const {
        adminSaveForm,
        token
    } = obj
    request({
        url: apis.admin_save + '?token=' + token,
        data: adminSaveForm
    }).then(res => {
        resolve(res);
    })
});
// 删除管理员
const removeAdmin = obj => new Promise((resolve, reject) => {
    const {
        removeAdminBO,
        token
    } = obj;
    request({
        url: apis.admin_del + '?token=' + token,
        data: removeAdminBO
    }).then(res => {
        resolve(res);
    })
});

const resetPassword = obj => new Promise((resolve, reject) => {
    const {
        resetForm,
        token
    } = obj;
    request({
        url: apis.admin_reset_password + '?token=' + token,
        data: resetForm
    }).then(res => {
        resolve(res);
    })
});

export default {
    findByRoleId,
    changeAdminRole,
    createAdmin,
    removeAdmin,
    resetPassword
}



// WEBPACK FOOTER //
// ./src/service/admin_api.js